import { Time } from '@/modules/shared/schemas/Time'

export const SLEEP_INDICATION = Object.freeze([
  'NEVER_SLEEP',
  'SLEEPY',
  'SLEEP_ALONE',
  'SCHEDULED_TIME',
  'SCHEDULED_TIME_ONLY'
] as const)

export const SLEEP_FREQUENCY_DAY = Object.freeze([
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY'
] as const)

export type SleepFrequency = {
  id: string
  sleepIndication: (typeof SLEEP_INDICATION)[number] | null

  sleepFrequency: {
    id: string | null
    day: (typeof SLEEP_FREQUENCY_DAY)[number]

    initialTime: Time
    endTime: Time
  }[]
  observation: string | null
  wakeUpObservations: string | null
}

export type UpdateSleepFrequencyDTO = Omit<
  SleepFrequency,
  'id' | 'sleepFrequency' | 'sleepIndication'
> & {
  sleepFrequency: Omit<SleepFrequency['sleepFrequency'][number], 'id'>[]
  sleepIndication: (typeof SLEEP_INDICATION)[number] | null
}
